import { CurrencyOption } from 'redux/types';
import world_currency_symbols from './world_currency_symbols.json';

export const CURRENCIES_LIST: CurrencyOption[] = Object.values(
  JSON.parse(JSON.stringify(world_currency_symbols))
);
